import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0639fc0f"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0639fc0f')) {
      api.createRecord('0639fc0f', component.options)
    } else {
      api.reload('0639fc0f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0639fc0f", function () {
      api.rerender('0639fc0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/packages/BjDateRangePicker/index.vue"
export default component.exports